export default "__VITE_ASSET__9fcf9ac1__"